<template>
  <fin-data-loader :resolver="loadData">
    <template #content>
      <div v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
           v-style:paddingRight="$valueByBreakpoint($finPadding.right)"
           class="pt-12">
        <h1 class="mb-3">Vergleichsgruppe anpassen</h1>
        <p class="mb-9 curr-share">Du bewertest die Aktie:
          <span style="font-weight: bold;">{{ rating.share.name }}</span>
        </p>
        <p v-if="!rating.sector" class="mt-2">
          <v-icon>icon-information</v-icon>
          Die von dir gewählte Aktie ist keiner Branche zugeordnet. Wähle hier zuerst eine Branche oder eine eigene
          Vergleichsgruppe aus.
        </p>
      </div>

      <div style="background-color: #FFFFFF">
        <fin-tabs :tab-items="compareGroupTabs"
                  :background-color-tabs="$finColors.background"
                  :background-color-tab-items="$finColors.primaryLight">
          <template #0>
            <fin-sector-tab :sector-items="sectorItems"
                            :sector="rating.sector"
                            :selected-shares="customCompGroupShares"
                            @input="val => customCompGroupShares = val"
                            @closeCompareGroupMode="$emit('closeCompareGroupMode')"
                            @copySelectionToCustomGroup="selectedTab = 1"
            />
          </template>
          <template #1>
            <fin-custom-group-tab :selected-shares="customCompGroupShares"
                                  :sector="rating.sector"
                                  @closeCompareGroupMode="$emit('closeCompareGroupMode')"
            />
          </template>
        </fin-tabs>
      </div>

    </template>
  </fin-data-loader>
</template>

<script>
import FinDataLoader from "@/components/common/DataLoader"
import {API, graphqlOperation} from "@/plugins/finAmplifyModules"
import {searchLevel1Sectors} from "@/views/protected/finTools/rate/shares/graphql"
import FinSectorTab from "@/components/pages/finTools/rate/shares/compareGroup/SectorTab"
import FinCustomGroupTab from "@/components/pages/finTools/rate/shares/compareGroup/CustomGroupTab"
import FinTabs from "@/components/common/Tabs"

export default {
  name: "finChangeCompareGroup",
  components: {FinTabs, FinSectorTab, FinCustomGroupTab, FinDataLoader},
  props: {
    rating: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      selectedSector: null,
      sectorItems: [],
      sectorSelectedShares: [],
      customCompGroupShares: [],
      selectedTab: 0,
      userCompareGroups: [],
      compareGroupTabs: [{name: "Branchen"}, {name: "Eigene Vergleichsgruppen"}]
    }
  },
  computed: {
    sharesBySector() {
      if (this.rating.share.searchLevel1Sectors) {
        return this.rating.share.searchLevel1Sectors
      }
      return []
    },
  },
  methods: {
    async loadData() {
      let result = await API.graphql(graphqlOperation(searchLevel1Sectors))
      this.sectorItems = result.data.searchSectors.items
    },
    copyToCustomCompareGroup() {
      if (this.customCompGroupShares.length === 0) {
        this.customCompGroupShares = this.sectorSelectedShares
      } else {
        this.sectorSelectedShares.forEach(s => {
          // just copy newly selected shares
          if (this.customCompGroupShares.find(cs => cs.id === s.id) === undefined) {
            this.customCompGroupShares.push(s)
          }
        })
      }

      this.selectedTab = 1
    },
  },
}
</script>

<style lang="scss" scoped>

.curr-share {
  font-family: $body-font-family;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.4;
  letter-spacing: normal;
  color: $fin-color-primary-dark;
}

.select-label {
  font-family: $body-font-family;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: $fin-color-primary-dark;
}

.cg-info {
  font-family: $body-font-family;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  letter-spacing: normal;
  color: $fin-color-cool-grey;
}
</style>
